import { useState } from 'react'

const steps = [
  {
    title: 'Understand',
    summary: 'Clarify the outcome, the current environment and what matters most.',
    detail:
      'We establish the business context, owners, users, systems, dependencies, constraints and risks that should shape the work.',
  },
  {
    title: 'Design',
    summary: 'Choose an appropriate route and make responsibilities explicit.',
    detail:
      'The design brings together suitable technology, delivery boundaries, change considerations, testing, ownership and a realistic route forward.',
  },
  {
    title: 'Implement',
    summary: 'Make controlled changes with validation built into the work.',
    detail:
      'Depth varies by engagement—from focused configuration to migration, integration, remediation, infrastructure or automation.',
  },
  {
    title: 'Document',
    summary: 'Leave a usable record of the environment and the decisions made.',
    detail:
      'Documentation, diagrams, configuration records, operating guidance and next actions are shaped for the people who will own the result.',
  },
  {
    title: 'Hand over',
    summary: 'Confirm what is complete, what remains and who owns the next step.',
    detail:
      'Handover closes the agreed work clearly and identifies any support, follow-on project, vendor or internal responsibility separately.',
  },
]

export function ProcessSteps() {
  const [active, setActive] = useState(0)

  return (
    <div className="process-steps">
      <div className="process-steps__rail" role="tablist" aria-label="How Informat works">
        {steps.map((step, index) => (
          <button
            type="button"
            role="tab"
            aria-selected={active === index}
            key={step.title}
            onClick={() => setActive(index)}
          >
            <span>{String(index + 1).padStart(2, '0')}</span>
            <strong>{step.title}</strong>
            <small>{step.summary}</small>
          </button>
        ))}
      </div>
      <div className="process-steps__detail" role="tabpanel" key={steps[active].title}>
        <span>{String(active + 1).padStart(2, '0')}</span>
        <h3>{steps[active].title}</h3>
        <p>{steps[active].detail}</p>
      </div>
    </div>
  )
}
